import ff from './ff';

export default class i15d { // 設備情報

static d_defs = {

/*
  DROP TABLE t_i15r;
  CREATE TABLE t_i15r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    i15rb21f INTEGER,
    i15rc11s TEXT,
    i15rc31s TEXT,
    i15rt11i INTEGER,
    i15rt32i INTEGER,
    i15rt33i INTEGER,
    i15rt41i INTEGER,
    i15ri11i INTEGER,
    i15ri21i INTEGER,
    i15ri31i INTEGER,
    i15rcx1i INTEGER,
    i15rcy1t TEXT,
    i15rcy1f INTEGER,
    i15rcz1i INTEGER
  );
  INSERT INTO t_i15r (_vsn, _ltt, i15rb21f, i15rc11s, i15rc31s, i15rt11i, i15rt32i, i15rt41i, i15ri11i, i15ri21i, i15ri31i, i15rcx1i, i15rcy1t, i15rcy1f, i15rcz1i)
  VALUES (1, 1, 1, '1', '０', 0, 10, 210, 2, 10, 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i15r (_vsn, _ltt, i15rb21f, i15rc11s, i15rc31s, i15rt11i, i15rt32i, i15rt41i, i15ri11i, i15ri21i, i15ri31i, i15rcx1i, i15rcy1t, i15rcy1f, i15rcz1i)
  VALUES (1, 1, 1, '2', 'Ⅰ', 0, 10, 210, 2, 10, 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i15r (_vsn, _ltt, i15rb21f, i15rc11s, i15rc31s, i15rt11i, i15rt32i, i15rt41i, i15ri11i, i15ri21i, i15ri31i, i15rcx1i, i15rcy1t, i15rcy1f, i15rcz1i)
  VALUES (1, 1, 1, '3', 'Ⅱ', 0, 10, 210, 2, 10, 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i15r (_vsn, _ltt, i15rb21f, i15rc11s, i15rc31s, i15rt11i, i15rt32i, i15rt41i, i15ri11i, i15ri21i, i15ri31i, i15rcx1i, i15rcy1t, i15rcy1f, i15rcz1i)
  VALUES (1, 1, 1, '4', 'Ⅲ', 10, 10, 210, 2, 10, 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i15r (_vsn, _ltt, i15rb21f, i15rc11s, i15rc31s, i15rt11i, i15rt32i, i15rt41i, i15ri11i, i15ri21i, i15ri31i, i15rcx1i, i15rcy1t, i15rcy1f, i15rcz1i)
  VALUES (1, 1, 1, '5', 'Ⅳ', 0, 10, 210, 2, 10, 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i15r (_vsn, _ltt, i15rb21f, i15rc11s, i15rc31s, i15rt11i, i15rt32i, i15rt41i, i15ri11i, i15ri21i, i15ri31i, i15rcx1i, i15rcy1t, i15rcy1f, i15rcz1i)
  VALUES (1, 1, 1, '6', 'Ⅴ', 10, 10, 210, 2, 10, 10, 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_i15r SET _fst = _key;
*/

  i15r: {
    0: {
      pfx: '団体種別',
      b_vsn: true,
      d_insFlds: {
        i15rc11s: '',
        i15rc31s: '',
        i15rt11i: -1,
        i15rt21i: -1,
      },
      dd_fldDefss: {
        i15rb21f: { 
          pfx: 'c20m_fst',
          type: 'Inp',
        },
        i15rc11s: {
          pfx: '団体種別ID',
          type: 'Inp',
          n_col: 4,
        },
        i15rc31s: {
          pfx: '団体種別名',
          type: 'Inp',
          n_col: 15,
        },
        i15rt11i: {
          pfx: '利用料金有無',
          type: 'Pck',
          n_col: 6,
          ld_iss: [
            { key: -1, pfx: ' ', },
            { key:  0, pfx: '無料', }, // 室
            { key: 10, pfx: '有料', }, // 室と同時に予約
          ]
        },
        i15rt32i: {
          pfx: 'エントリー申込',
          type: 'Pck',
          n_col: 6,
          ld_iss: [
            { key: -1, pfx: ' ', },
            { key:  0, pfx: '不可', }, // 室
            { key: 10, pfx: '可', }, // 室と同時に予約
          ]
        },
        i15rt33i: {
          pfx: '優先エントリー申込',
          type: 'Pck',
          n_col: 6,
          ld_iss: [
            { key: -1, pfx: ' ', },
            { key:  0, pfx: '不可', }, // 室
            { key: 10, pfx: '可', }, // 室と同時に予約
          ]
        },
        i15rt41i: {
          pfx: '予約可能期間',
          type: 'Pck',
          n_col: 7,
          ld_iss: [
            { key:  -1, pfx: ' ', },
            { key: 120, pfx: '２週間前', },
            { key: 130, pfx: '３週間前', },
            { key: 200, pfx: '当月', },
            { key: 210, pfx: '１ヶ月前', },
            { key: 220, pfx: '２ヶ月前', },
            { key: 300, pfx: '予約解禁後', },
          ]
        },
        i15ri11i: {
          pfx: '予約可能件数（２ヶ月前）',
          type: 'Inp',
          n_col: 6,
          ini: 2,
          bsd: '件',
        },
        i15ri21i: {
          pfx: '予約可能件数（１ヶ月前）',
          type: 'Inp',
          n_col: 6,
          ini: 2,
          bsd: '件',
        },
        i15ri31i: {
          pfx: '予約可能件数（当月）',
          type: 'Inp',
          n_col: 6,
          ini: 2,
        },

        i15ri12i: {
          pfx: '予約基準日（２ヶ月前）',
          type: 'Inp',
          n_col: 6,
          ini: 1,
        },
        i15ri22i: {
          pfx: '予約基準日（１ヶ月前）',
          type: 'Inp',
          n_col: 6,
          ini: 1,
        },
        i15ri32i: {
          pfx: '予約基準日（当月）',
          type: 'Inp',
          n_col: 6,
          ini: 1,
        },
      },
    },
  },

/*
  DROP TABLE t_i150;
  CREATE TABLE t_i150 (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    i150b21f INTEGER,
    i150br1k INTEGER,
    i150b41f INTEGER,
    i150cx1i INTEGER,
    i150cy1t TEXT,
    i150cy1f INTEGER,
    i150cz1i INTEGER
  );
*/
  i150: {
    0: {
      pfx: '予約不可室・設備',
      b_vsn: true,
      d_insFlds: {
        i150br1k: -1,
        i150b41f: -1,
      },
      dd_fldDefss: {
        i150b21f: { 
          pfx: 'c20m_fst',
          type: 'Inp',
        },
        i150br1k: { // i15r_key
          pfx: '団体種別',
          type: 'Inp',
          n_col: 4,
        },
        i150b41f: {
          pfx: '室・設備',
          type: 'Pck',
          n_col: 15,
        },
      },
    },
  },

};

};
